export function reset (state) {
	state.club = {};
}
